module.exports = __webpack_public_path__ + "static/facebook-e2688a4b65b82dd7a7d6f6ee17228a2c.png";